import { GlobalServiceService } from "src/app/services/global-service.service";
import { LocalstorageService } from "./../services/localstorage.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";
import { ApiBasic } from "../services/api-basic";
import { Subscription } from "rxjs";

@Injectable()
export class ReportService {
  // private httpOptions = {
  //   headers: new HttpHeaders({
  //     "Content-Type": "application/json",
  //     "Authorization": `Bearer ${this.token}`
  //   })
  // }
  appBase: any;
  private token = "";
  subscription: Subscription;
  constructor(
    private http: HttpClient,
    public api: ApiBasic,
    public apiBasic: ApiBasic,
    public _global: GlobalServiceService,
    private _localstorage: LocalstorageService
  ) {
    // this._global.base_url = this._global.base_url;
    this.token = _global.token;
    this.subscription = this._localstorage.getToken().subscribe((message) => {
      this.token = _global.token;
    });
  }

  //Extrae la base64 mandando el link
  extraerBaselink(link) {
    let headers = new Headers({
      Authorization: this.token,
    });
    let dataBody = {
      url_image: link,
    };
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.post(
      this._global.base_url + "/reports/convert/toimage",
      dataBody,
      httpOptions
    );
  }

  public reportsInspect(data: any, filters: any) {
    let headers = new Headers({
      Authorization: this.token,
    });

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    var queryData = this.api.stringfyObject(data);
    let queryFilter = this.api.stringfyFilter(filters);
    return this.http.get(
      this._global.base_url + "/reports/?" + queryData + "&filters=" + queryFilter,
      httpOptions
    );
  }

  public close(reportId: number, data: any) {
    let headers = new Headers({
      Authorization: this.token,
    });

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.put(
      this._global.base_url + "/reports/" + reportId + "/close",
      data,
      httpOptions
    );
  }

  public maintenanceHojaRuta(maintenanceID) {
    let headers = new Headers({
      Authorization: this.token,
    });
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.get(
      this._global.base_url + "/maintenances/" + maintenanceID + "/page_route",
      httpOptions
    );
  }

  deleteImage(imageData) {
    return this.http.post(this._global.base_url + "/files/deletefiles", imageData);
  }

  public reports(data: any, filters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    var queryData = this.api.stringfyObject(data);
    let queryFilter = this.api.stringfyFilter(filters);
    return this.http.get(
      this._global.base_url + "/reports/?" + queryData + "&filters=" + queryFilter,
      httpOptions
    );
  }

  public reportsCargaInspeccion(data: any, id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.post(
      this._global.base_url + "/reports/masive/reportes?user_id=" + id,
      data,
      httpOptions
    );
  }

  public reportsCargaInspeccionFile(data: any, id) {
    const httpOptions = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.patch(
      this._global.base_url + "/reports/masive/reportes?user_id=" + id,
      data,
      httpOptions
    );
  }

  public reportsCargaInspeccionFileUpdate(data: any, id) {
    const httpOptions = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.put(
      this._global.base_url + "/reports/masive/format/update?user_id=" + id,
      data,
      httpOptions
    );
  }

  public reportsList(data: any, filters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    var queryData = this.api.stringfyObject(data);
    let queryFilter = this.api.stringfyFilter(filters);
    let queryFilter2;
    if (filters) {
      if (filters.filters) {
        queryFilter2 = this.api.stringfyFilter2(filters.filters);
      } else {
        queryFilter2 = this.api.stringfyFilter2(filters);
      }

      var mes_ejecutado = JSON.stringify(filters.mes_ejecutado);
      var anio = JSON.stringify(filters.anio);

      if (filters.anio || filters.filters.anio) {
        return this.http.get(
          `${this._global.base_url}/reports/?${queryData}&filters=${queryFilter2}&tipo_reporte=0`,
          httpOptions
        );
      } else if (!filters.mes_ejecutado) {
        return this.http.get(
          this._global.base_url +
            `/reports/?${queryData}&filters={"anio_creado":${anio}}&tipo_reporte=0`,
          httpOptions
        );
      } else {
        if (filters.mes_ejecutado[0] === "TODOS") {
          return this.http.get(
            this._global.base_url +
              `/reports/?${queryData}&filters={"anio_creado":${anio}}&tipo_reporte=0`,
            {}
          );
        } else {
          if (Array.isArray(filters.mes_ejecutado)) {
            // return this.http.get(`${this._global.base_url}/reports/?${queryData}&filters={"mes_ejecutado":${mes_ejecutado}}&tipo_reporte=0`, {});
            return this.http.get(
              `${this._global.base_url}/reports/?${queryData}&filters={"mes_ejecutado":${mes_ejecutado},"anio_creado":${anio}}&tipo_reporte=0`,
              {}
            );
          } else {
            // return this.http.get(`${this._global.base_url}/reports/?${queryData}&filters={"mes_ejecutado":[${mes_ejecutado}]}&tipo_reporte=0`, {});
            return this.http.get(
              `${this._global.base_url}/reports/?${queryData}&filters={"mes_ejecutado":[${mes_ejecutado}],"anio_creado":${anio}}&tipo_reporte=0`,
              {}
            );
          }
        }
      }
    } else {
      return this.http.get(
        this._global.base_url +
          "/reports/?" +
          queryData +
          "&filters= {}" +
          "&tipo_reporte=0",
        {}
      );
    }
  }

  public reportsListInspeccion(data: any, filters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    var queryData = this.api.stringfyObject(data);
    let queryFilter = this.api.stringfyFilter(filters);
    let queryFilter2;

    if (filters) {
      if (filters.filters) {
        queryFilter2 = this.api.stringfyFilter2(filters.filters);
      } else {
        queryFilter2 = this.api.stringfyFilter2(filters);
      }

      var mes_ejecutado = JSON.stringify(filters.mes_ejecutado);
      var anio = JSON.stringify(filters.anio);

      return this.http.get(
        `${this._global.base_url}/reports/?${queryData}&filters=${queryFilter2}&tipo_reporte=1`,
        httpOptions
      );

      // if (filters.anio || filters.filters.anio) {

      //   return this.http.get(`${this._global.base_url}/reports/?${queryData}&filters=${queryFilter2}&tipo_reporte=1`, httpOptions)

      // } else if (!filters.mes_ejecutado) {

      //   return this.http.get(this._global.base_url + `/reports/?${queryData}&filters={"anio_creado":${anio}}&tipo_reporte=1`, httpOptions);
      // } else {

      //   if (filters.mes_ejecutado[0] === "TODOS") {

      //     return this.http.get(this._global.base_url + `/reports/?${queryData}&filters={"anio_creado":${anio}}&tipo_reporte=1`, {});

      //   } else {
      //     if (Array.isArray(filters.mes_ejecutado)) {

      //       return this.http.get(`${this._global.base_url}/reports/?${queryData}&filters={"mes_ejecutado":${mes_ejecutado},"anio_creado":${anio}}&tipo_reporte=1`, {});

      //     } else {

      //       return this.http.get(`${this._global.base_url}/reports/?${queryData}&filters={"mes_ejecutado":[${mes_ejecutado}],"anio_creado":${anio}}&tipo_reporte=1`, {});

      //     }
      //   }
      // }
    } else {
      return this.http.get(
        this._global.base_url +
          "/reports/?" +
          queryData +
          "&filters= {}" +
          "&tipo_reporte=1",
        {}
      );
    }
  }

  public getInfoFiltersRegion(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url + "/filters/regions/?" + queryData,
      httpOptions
    );
  }

  public getInfoFiltersLocacions(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url + "/filters/locations/?" + queryData,
      httpOptions
    );
  }

  public getTypeMaintence() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this._global.base_url + "/filters/maintenance/type/",
      httpOptions
    );
  }

  public getSubtypeMaintence(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    if (data.status != "Pendiente") {
      return this.http.get(
        `${this._global.base_url}/filters/maintenance/subtype/?maintenance_id=${data.id}`,
        httpOptions
      );
    } else {
      return this.http.get(
        `${this._global.base_url}/filters/maintenance/subtype/?maintenance_id=${data.id}&status="${data.status}"`,
        httpOptions
      );
    }
  }

  public create(data: any, force) {
    console.log(data);

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.post(
      this._global.base_url + "/reports/create?force_create=" + force,
      data,
      httpOptions
    );
  }

  public update(data: any, id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.patch(
      this._global.base_url + "/reports/" + id + "/",
      data,
      httpOptions
    );
  }
  public updateInspeccion(data: any, id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.post(
      this._global.base_url + "/reports/inspeccion/proccess",
      data,
      httpOptions
    );
  }

  public delete(user_id, id_reporte) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.delete(
      this._global.base_url + "/reports/" + id_reporte + "/detail?user_id=" + user_id,
      httpOptions
    );
  }

  public addImage(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.post(
      this._global.base_url + "/maintenances/" + maintenanceID + "/images",
      data,
      httpOptions
    );
  }

  public getImages(maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this._global.base_url + "/reports/" + maintenanceID + "/images",
      httpOptions
    );
  }

  public maintenanceImages(data: any, maintenanceID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    var queryData = this.api.stringfyObject(data);
    return this.http.get(
      this._global.base_url + "/maintenances/" + maintenanceID + "/images?" + queryData,
      httpOptions
    );
  }

  public dashboard(data: any, filters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    var queryData = this.api.stringfyObject(data);
    let queryFilter = this.api.stringfyFilter(filters);

    if (filters)
      return this.http.get(
        `${this._global.base_url}/reports/dashboard?${queryData}&filters=${queryFilter}`,
        httpOptions
      );
    else
      return this.http.get(
        this._global.base_url + "/reports/dashboard?" + queryData,
        httpOptions
      );
  }

  public dashboard2(data: any, filters: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    var queryData = this.api.stringfyObject(data);
    var queryFilter = this.api.stringfyFilter(filters);
    let queryFilter2;

    if (filters) {
      if (filters.filters) {
        queryFilter2 = this.api.stringfyFilter2(filters.filters);
      } else {
        queryFilter2 = this.api.stringfyFilter2(filters);
      }

      if (filters.anio || filters.filters.anio) {
        return this.http.get(
          `${this._global.base_url}/reports/dashboard?${queryData}&filters=${queryFilter2}`,
          httpOptions
        );
      } else if (filters.mes_ejecutado) {
        // return this.http.get(`${this._global.base_url}/reports/dashboard?${queryData}&filters={"mes_ejecutado": "${filters.mes_ejecutado}" } `, {});
        var mes_ejecutados = JSON.stringify(filters.mes_ejecutado);
        if (Array.isArray(filters.mes_ejecutado)) {
          return this.http.get(
            `${this._global.base_url}/reports/dashboard?${queryData}&filters={"mes_ejecutado":${mes_ejecutados}}`,
            httpOptions
          );
        } else {
          return this.http.get(
            `${this._global.base_url}/reports/dashboard?${queryData}&filters={"mes_ejecutado":[${mes_ejecutados}]} `,
            httpOptions
          );
        }
      } else {
        var type = JSON.stringify(filters.filters.type_site);
        var cluster = JSON.stringify(filters.filters.clusterName);
        var location = JSON.stringify(filters.filters.locationName);
        var region = JSON.stringify(filters.filters.regionName);
        var mes_ejecutado = JSON.stringify(filters.filters.mes_ejecutado);

        var filterss = {
          type_site: type,
          clusterName: cluster,
          regionName: region,
          locationName: location,
          mes_ejecutado: mes_ejecutado,
        };

        if (
          filterss.type_site != undefined &&
          filterss.clusterName != undefined &&
          filterss.regionName != undefined &&
          filterss.locationName != undefined &&
          mes_ejecutado != null
        ) {
          if (Array.isArray(filters.filters.mes_ejecutado)) {
            return this.http.get(
              `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
            "clusterName":${cluster}, "regionName": ${region}, "locationName":${location}, "mes_ejecutado":${mes_ejecutado}} `,
              {}
            );
          } else {
            return this.http.get(
              `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
            "clusterName":${cluster}, "regionName": ${region}, "locationName":${location}, "mes_ejecutado":[${mes_ejecutado}]} `,
              {}
            );
          }
        } else if (
          filterss.type_site != undefined &&
          filterss.clusterName != undefined &&
          filterss.regionName != undefined &&
          filterss.locationName != undefined
        ) {
          return this.http.get(
            `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
            "clusterName":${cluster}, "regionName": ${region}, "locationName":${location}} `,
            {}
          );
        } else {
          if (
            filterss.type_site != undefined &&
            filterss.clusterName != undefined &&
            filterss.regionName != undefined &&
            mes_ejecutado != null
          ) {
            if (Array.isArray(filters.filters.mes_ejecutado)) {
              return this.http.get(
                `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
              "clusterName":${cluster}, "regionName": ${region}, "mes_ejecutado":${mes_ejecutado}}`,
                {}
              );
            } else {
              return this.http.get(
                `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
              "clusterName":${cluster}, "regionName": ${region}, "mes_ejecutado":${mes_ejecutado}} `,
                {}
              );
            }
          } else if (
            filterss.type_site != undefined &&
            filterss.clusterName != undefined &&
            filterss.regionName != undefined
          ) {
            return this.http.get(
              `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
                "clusterName":${cluster}, "regionName": ${region}} `,
              {}
            );
          } else {
            if (
              filterss.type_site != undefined &&
              filterss.clusterName != undefined &&
              mes_ejecutado != null
            ) {
              if (Array.isArray(filters.filters.mes_ejecutado)) {
                return this.http.get(
                  `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},
                "clusterName":${cluster}, "mes_ejecutado":${mes_ejecutado}} `,
                  {}
                );
              } else {
                return this.http.get(
                  `${this._global.base_url}/reports/dashboards?${queryData}&filters={"type_site":${type},
                "clusterName":${cluster}, "mes_ejecutado":${mes_ejecutado}} `,
                  {}
                );
              }
            } else if (
              filterss.type_site != undefined &&
              filterss.clusterName != undefined
            ) {
              return this.http.get(
                `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},"clusterName":${cluster}} `,
                {}
              );
            } else {
              if (filterss.type_site != undefined && mes_ejecutado != null) {
                if (Array.isArray(filters.filters.mes_ejecutado)) {
                  return this.http.get(
                    `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},"mes_ejecutado":${mes_ejecutado}} `,
                    {}
                  );
                } else {
                  return this.http.get(
                    `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site":${type},"mes_ejecutado":${mes_ejecutado}} `,
                    {}
                  );
                }
              } else if (filterss.type_site != undefined) {
                return this.http.get(
                  `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site": ${type} } `,
                  {}
                );
              } else {
                if (mes_ejecutado != null) {
                  if (Array.isArray(filters.filters.mes_ejecutado)) {
                    return this.http.get(
                      `${this._global.base_url}/reports/dashboard?${queryData}&filters={"mes_ejecutado":${mes_ejecutado}} `,
                      {}
                    );
                  } else {
                    return this.http.get(
                      `${this._global.base_url}/reports/dashboard?${queryData}&filters={"mes_ejecutado":${mes_ejecutado}} `,
                      {}
                    );
                  }
                } else {
                  if (filters.filters.type_site != null) {
                    return this.http.get(
                      `${this._global.base_url}/reports/dashboard?${queryData}&filters={"type_site": ${type} } `,
                      {}
                    );
                  }
                }
              }
            }
          }
        }
      }
    } else {
      if (filters) {
        return this.http.get(
          `${this._global.base_url}/reports/dashboard?${queryData}&filters=${queryFilter}`,
          {}
        );
      } else {
        return this.http.get(
          this._global.base_url + "/reports/dashboard?" + queryData,
          {}
        );
      }
    }
  }

  public reportSatisfaction(data) {
    var queryData = this.api.stringfyFilter(data.filters);
    window.open(
      this._global.base_url +
        "/reports/user_satisfaction?user_id=" +
        data.user_id +
        "&filters=" +
        queryData +
        "&format_data=excell"
    );
  }

  public reportPdf(report_id, user_id) {
    window.open(
      this._global.base_url + "/report-view/report/" + report_id + "?user_id=" + user_id
    );
  }

  public bulkload(action, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.put(
      this._global.base_url +
        "/maintenances/bulkload/load_maintenances?action=" +
        action,
      data,
      httpOptions
    );
  }

  public aceptReport(report_id, data) {
    console.log(this.token);
    console.log(report_id);
    console.log(data);

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.put(
      this._global.base_url +
        "/reports/" +
        report_id +
        "/accept?user_id=" +
        data.user_id,
      data,
      httpOptions
    );
  }

  public acceptEvaluation(report_id, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.put(
      this._global.base_url +
      "/reportevaluation/" +
      report_id +
      "/accept?user_id=" +
      user_id,
      httpOptions
    )
  }

  public deniedEvaluation(report_id, user_id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.put(
      this._global.base_url +
      "/reportevaluation/" +
      report_id +
      "/denied?user_id=" +
      user_id,
      httpOptions
    )
  }

  public approveReport(report_id, user_id) {
    console.log(report_id, user_id);

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    console.log(this.token);

    return this.http.put(
      this._global.base_url +
        "/reportsapprovate/" +
        report_id +
        "/approve?user_id=" +
        user_id,
      httpOptions
    );
  }

  public addImagev2() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    // return this.http.post(
    //   this._global.base_url + "/maintenances/" + maintenanceID + "/images",
    //   data,
    //   httpOptions
    // );
  }

  public deniedReport(report_id, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    return this.http.put(
      this._global.base_url +
        "/reports/" +
        report_id +
        "/denied?user_id=" +
        data.user_id,
      data,
      httpOptions
    );
  }

  public catalogoDeRechazo() {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(this._global.base_url + "/catalogs/refusetype", httpOptions);
  }

  public getReportsWithoutRating(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    // http://femsadesarrollo.energetikadevelepment.com/maintenances/mantosacalificar
    const data = {
      filter: `${this._global.base_url}/reports/dashboard?user_id=${id}`,
    };
    return this.http.post(
      `${this._global.base_url}/reportesacalificar`,
      data,
      httpOptions
    );
  }

  public getInspeccion(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    const data = {
      id_report: id,
    };
    return this.http.post(
      `${this._global.base_url}/reports/check/relinspeccion`,
      data,
      httpOptions
    );
  }
  public getInspeccionToReport(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };

    const data = {
      id_report: id,
    };
    return this.http.post(
      `${this._global.base_url}/reports/check/report`,
      data,
      httpOptions
    );
  }

  // id_maintenance=54525&type_status=reprogramar&mes=FEBRERO&fecha=2021-02-01
  public changeStatusReprogram(id_mantenance, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this._global.base_url +
        "/maintenances/closeorreschedule?id_maintenance=" +
        id_mantenance +
        "&type_status=reprogramar" +
        "&mes=" +
        data.month +
        "&fecha=" +
        data.date +
        "&type_maintenance=" +
        data.type_maintenance,
      httpOptions
    );
  }

  public addNote(data: any, reportID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.post(
      this._global.base_url + "/maintenances/" + reportID + "/notes",
      data,
      httpOptions
    );
  }

  public getArchive(id_report) {
    const httpOptions = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this._global.base_url +
        "/maintenances/licitado/homologado?id_maintenance=" +
        id_report,
      httpOptions
    );
  }

  public postArchive(id_report, idProfile, formdata, type) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      }),
    };
    //type brief/cotizacion
    return this.http.post(
      `${this._global.base_url}/maintenances/licitado/homologado?id_maintenance=${id_report}&id_user=${idProfile}&&type=${type}`,
      formdata,
      httpOptions
    );
  }

  public patchArchive(
    id_report,
    idProfile,
    formdata,
    action,
    type,
    idArchive,
    costo
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.patch(
      `${this._global.base_url}/maintenances/licitado/homologado?id_maintenance=${id_report}&id_user=${idProfile}&action=${action}&&type=${type}&&id_archive=${idArchive}&&costo=${costo}`,
      formdata,
      httpOptions
    );
  }

  public patchArchiveRechazar(
    id_report,
    idProfile,
    formdata,
    action,
    type,
    idArchive
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.patch(
      `${this._global.base_url}/maintenances/licitado/homologado?id_maintenance=${id_report}&id_user=${idProfile}&action=${action}&&type=${type}&&id_archive=${idArchive}`,
      formdata,
      httpOptions
    );
  }

  public postArchiveCotizacion(
    id_report,
    idProfile,
    formdata,
    type,
    costo
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      }),
    };
    //type brief/cotizacion
    return this.http.post(
      `${this._global.base_url}/maintenances/licitado/homologado?id_maintenance=${id_report}&id_user=${idProfile}&&type=${type}&&costo=${costo}`,
      formdata,
      httpOptions
    );
  }

  public patchArchiveCotizacion(
    id_report,
    idProfile,
    formdata,
    action,
    type,
    idArchive
  ) {
    const httpOptions = {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.patch(
      `${this._global.base_url}/maintenances/licitado/homologado?id_maintenance=${id_report}&id_user=${idProfile}&action=${action}&&type=${type}&&id_archive=${idArchive}`,
      formdata,
      httpOptions
    );
  }

  getRecorridoUsuario(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(this._global.base_url + `/usertour/${id}/user`, httpOptions);
  }

  getRecorridoImg(id) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this._global.base_url + `/usertour/${id}/detail/images`,
      httpOptions
    );
  }

  getConvertirImgBase(url) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      }),
    };
    return this.http.get(
      this._global.base_url + `/usertour/image/convert/base64?url=${url}`,
      httpOptions
    );
  }
}

/*


@Injectable()
export class ReportsProvider {

  private token = ""
  constructor(public http: Http, public api: ApiBasic) {

  }


  public  reports( data: any ,filters: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    var queryData=this.api.stringfyObject(data)
    let queryFilter=this.api.stringfyFilter(filters)
    return this.http.get(this._global.base_url+"/reports?"+queryData+'&filters='+queryFilter,options)
      .map(res => res.json())
        .toPromise();
  }

  public  concepts(){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.get(this._global.base_url+"/reports/concepts",options)
      .map(res => res.json())
        .toPromise();
  }

  public  report( data: any ,filters: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    var queryData=this.api.stringfyObject(data)
    let queryFilter=this.api.stringfyFilter(filters)
    return this.http.get(this._global.base_url+"/reports/all?"+queryData+'&filters='+queryFilter,options)
      .map(res => res.json())
        .toPromise();
  }

  public  dashboard( data: any ,filters: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    var queryData=this.api.stringfyObject(data)
    let queryFilter=this.api.stringfyFilter(filters)
    return this.http.get(this._global.base_url+"/reports/dashboard?"+queryData+'&filters='+queryFilter,options)
      .map(res => res.json())
        .toPromise();
  }


  public  accept(reportId: number ,data: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.put(this._global.base_url+"/reports/"+reportId+"/accept",data,options)
      .map(res => res.json())
        .toPromise();
  }

  public  denied(reportId: number ,data: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.put(this._global.base_url+"/reports/"+reportId+"/denied",data,options)
      .map(res => res.json())
        .toPromise();
  }


  public  close(reportId: number ,data: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.put(this._global.base_url+"/reports/"+reportId+"/close",data,options)
      .map(res => res.json())
        .toPromise();
  }


  public  create(data: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.post(this._global.base_url+"/reports/create",data,options)
      .map(res => res.json())
        .toPromise();
  }

  public  createNoPromise(data: any ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.post(this._global.base_url+"/reports/create",data,options)
      .map(res => {
        var aux = {}
        aux["response"]=res.json()
        aux["data_response"] = data;
        return aux;
      })
  }

  public  addNote( data: any ,reportID: number ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.post(this._global.base_url+"/reports/"+reportID+"/notes",data,options)
      .map(res => res.json())
        .toPromise();
  }

  public  addNoteNoPromise( data: any ,reportID: number ){
    let headers = new Headers(
      {
        'Authorization' : this.token
      });
    let options = new RequestOptions({ headers: headers});
    return this.http.post(this._global.base_url+"/reports/"+reportID+"/notes",data,options)
      .map(res => {
        var aux = {}
        aux["response"]=res.json()
        aux["data_response"] = data;
        return aux;
      })
  }

}*/
